import React from "react";
import AutomatedReplyAlert from "./widget/AutomatedReplyAlert";
import { AutomatedReplyContextProvider } from "../../../provider/work_profile/automated_reply/AutomatedReplyContextProvider";

const AutomatedReplyContent = (props: { isModal?: boolean }) => {
  return (
    <AutomatedReplyContextProvider>
      <AutomatedReplyAlert />
    </AutomatedReplyContextProvider>
  );
};

export default AutomatedReplyContent;
